import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';

import {RatingViewComponent} from './rating-view.component';


@NgModule({
  declarations: [
    RatingViewComponent
  ],
  exports: [
    RatingViewComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ]
})
export class RatingViewModule {
}
